require('./RAExpectedProfitability.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');
// @ components
const RAPillButtons = require('components/RAComponents/RAPillButtons/RAPillButtons');
const RAProbabilityTag = require('components/RAComponents/RAProbabilityTag/RAProbabilityTag');
const RAProjectionChart = require('components/RAComponents/RAProjectionChart/RAProjectionChart');
// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ utilities
import { FormattedText } from 'core/i18n';

class RAExpectedProfitability extends React.Component {
    constructor(props) {
        super(props);

        this.formatter = this.formatter.bind(this);
    }

    formatter(value) {
        return <FormattedText value="rentabilityGraph-nYears" injectedStrings={[value]} />;
    }

    getHeaderSection() {
        const {
            chartButtons,
            chartYears,
            disabled,
            headerMarginBottom,
            isObjectiveTracking,
            onChangeYears,
            probability,
            subtitle,
            title,
            titleFontBigger,
            titleTooltip,
        } = this.props;
        const headerClasses = classNames('ra-expected-profitability__header', {
            'ra-expected-profitability__header--margin-bottom-none': headerMarginBottom,
        });
        const titleClasses = classNames('ra-expected-profitability__title hidden-xs', {
            'ra-expected-profitability__title--bigger-font': titleFontBigger,
        });
        const subtitleClasses = classNames('ra-expected-profitability__subtitle hidden-xs', {
            'ra-expected-profitability__subtitle--smaller-font': isObjectiveTracking,
        });
        const titleElement = !!title && (
            <div className="ra-expected-profitability__header-texts">
                <h2 className={titleClasses}>
                    {title}
                    {titleTooltip}
                </h2>
            </div>
        );
        const chartButtonsElement = !!chartButtons && (
            <div className="ra-expected-profitability__buttons">
                <RAPillButtons
                    changeOption={onChangeYears}
                    selectedOption={chartYears}
                    buttons={chartButtons}
                    formatter={this.formatter}
                    disabled={disabled}
                />
            </div>
        );
        const probabilityElement = !!probability && (
            <span className="ra-expected-profitability__probability-tag">
                <RAProbabilityTag label={probability} />
            </span>
        );
        const subtitleElement = !!subtitle && (
            <h5 className={subtitleClasses}>
                {subtitle}
                {probabilityElement}
            </h5>
        );

        return (
            <div>
                <div className={headerClasses}>
                    {titleElement}
                    {chartButtonsElement}
                </div>
                {subtitleElement}
            </div>
        );
    }

    getChartSection() {
        const { loading } = this.props;
        let content;

        if (loading) {
            content = <LoadingSection />;
        } else {
            const { chartYears, chartData, disabled, isObjectiveTracking, tickInfo, objAmount, actualAmount } =
                this.props;

            content = (
                <RAProjectionChart
                    actualAmount={actualAmount}
                    data={chartData}
                    disabled={disabled}
                    isObjectiveTracking={isObjectiveTracking}
                    loading={loading}
                    objAmount={objAmount}
                    tickInfo={tickInfo}
                    years={chartYears}
                />
            );
        }

        return content;
    }

    getFooterSection() {
        return (
            <div className="ra-expected-profitability__footer hidden-xs">
                <div className="ra-expected-profitability__text">
                    <FormattedText value="rentabilityGraph-text" />
                </div>
                <div className="ra-expected-profitability__legends">
                    <div className="ra-expected-profitability__legend ra-expected-profitability--light-blue">
                        <div className="ra-expected-profitability__circle-wrapper">
                            <span className="ra-expected-profitability__circle" />
                        </div>
                        <div className="ra-expected-profitability__legend-text">
                            <div className="ra-expected-profitability__legend-title">
                                <FormattedText value="rentabilityGraph-maximumLabel" />
                            </div>
                            <div className="ra-expected-profitability__legend-info">
                                <FormattedText value="rentabilityGraph-legendInfoLast" />
                            </div>
                        </div>
                    </div>
                    <div className="ra-expected-profitability__legend ra-expected-profitability--white">
                        <div className="ra-expected-profitability__circle-wrapper">
                            <span className="ra-expected-profitability__circle" />
                        </div>
                        <div className="ra-expected-profitability__legend-text">
                            <div className="ra-expected-profitability__legend-title">
                                <FormattedText value="rentabilityGraph-expectedLabel" />
                            </div>
                            <div className="ra-expected-profitability__legend-info">
                                <FormattedText value="rentabilityGraph-legendInfoMiddle" />
                            </div>
                        </div>
                    </div>
                    <div className="ra-expected-profitability__legend ra-expected-profitability--grey">
                        <div className="ra-expected-profitability__circle-wrapper">
                            <span className="ra-expected-profitability__circle" />
                        </div>
                        <div className="ra-expected-profitability__legend-text">
                            <div className="ra-expected-profitability__legend-title">
                                <FormattedText value="rentabilityGraph-minimumLabel" />
                            </div>
                            <div className="ra-expected-profitability__legend-info">
                                <FormattedText value="rentabilityGraph-legendInfoFirst" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { disabled } = this.props;
        const topClassName = classNames('ra-expected-profitability', {
            'ra-expected-profitability--disabled': disabled,
        });
        const chartSection = this.getChartSection();
        const headerSection = this.getHeaderSection();
        const footerSection = this.getFooterSection();

        return (
            <div className={topClassName}>
                {headerSection}
                {chartSection}
                {footerSection}
            </div>
        );
    }
}

RAExpectedProfitability.propTypes = {
    actualAmount: PropTypes.number,
    chartButtons: PropTypes.object,
    chartData: PropTypes.array.isRequired,
    chartYears: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    isObjectiveTracking: PropTypes.bool,
    loading: PropTypes.bool,
    objAmount: PropTypes.number,
    onChangeYears: PropTypes.func,
    probability: PropTypes.string,
    showFooter: PropTypes.bool,
    subtitle: PropTypes.string,
    tickInfo: PropTypes.object,
    title: PropTypes.string,
    titleTooltip: PropTypes.object,
};

RAExpectedProfitability.defaultProps = {
    disabled: false,
    error: false,
    isObjectiveTracking: false,
    onChangeYears: () => {},
    showFooter: true,
};

module.exports = RAExpectedProfitability;
